"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMultiple = exports.duplicateRemoval = exports.arr2Obj = exports.numberInputFormat = exports.numberInputParser = exports.clearNoNum = exports.camelCase = exports.lowerCase = exports.localUnderScoreCase = exports.str2Arr = exports.arr2Str = exports.transformEnum = exports.formatTime = exports.numberFormat = void 0;
var bv_data_1 = require("bv-data");
var bv_validator_1 = require("bv-validator");
var lodash_1 = require("lodash");
var dayjs_1 = __importDefault(require("dayjs"));
// eslint-disable-next-line no-misleading-character-class
var trimReg = /[\u200b\u200d\u200c\u200e\u200f\ufeff]*/g;
// 去掉隐藏空格
var trimZero = function (str) { return str.replace(trimReg, ''); };
// 转换返回值为驼峰命名
var camelCase = function (obj) {
    var ret = obj;
    if (ret === undefined || ret === null) {
        return ret;
    }
    if (bv_validator_1.isArray(obj)) {
        ret = (obj).map(function (x) { return camelCase(x); });
    }
    else if (bv_validator_1.isStr(obj)) {
        ret = trimZero(obj);
    }
    else if (bv_validator_1.isObj(obj)) {
        ret = {};
        // eslint-disable-next-line no-restricted-syntax
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var child = obj[key];
                if (child !== undefined) {
                    ret[lodash_1.camelCase(key)] = camelCase(child);
                }
            }
        }
    }
    return ret;
};
exports.camelCase = camelCase;
// 转换返回值为下划线命名
var localUnderScoreCase = function (x) { return x.replace(/([A-Z])/g, '_$1').toLowerCase(); };
exports.localUnderScoreCase = localUnderScoreCase;
var lowerCase = function (obj) {
    var ret = obj;
    if (ret === undefined || ret === null) {
        return ret;
    }
    if (bv_validator_1.isArray(obj)) {
        ret = obj.map(function (x) { return lowerCase(x); });
    }
    else if (bv_validator_1.isStr(obj)) {
        ret = trimZero(obj);
    }
    else if (bv_validator_1.isObj(obj)) {
        ret = {};
        // eslint-disable-next-line no-restricted-syntax
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var child = obj[key];
                if (child !== undefined) {
                    ret[localUnderScoreCase(key)] = lowerCase(child);
                }
            }
        }
    }
    return ret;
};
exports.lowerCase = lowerCase;
var str2Arr = function (value, split) {
    if (split === void 0) { split = ','; }
    if (bv_validator_1.isStr(value)) {
        return value.split(split).filter(function (item) { return item !== ''; });
    }
    return value;
};
exports.str2Arr = str2Arr;
var arr2Str = function (value, split) {
    if (split === void 0) { split = ','; }
    if (bv_validator_1.isArray(value)) {
        return value.join(split);
    }
    return value;
};
exports.arr2Str = arr2Str;
var formatTime = function (x, format) {
    if (format === void 0) { format = 'YYYY年M月D日 HH:mm:ss'; }
    return (x ? dayjs_1.default(x).format(format) : bv_data_1.placeholder);
};
exports.formatTime = formatTime;
// 添加千分位
var numberFormat = function (val, cent, suffix) {
    if (cent === void 0) { cent = 2; }
    if (val === null || val === undefined) {
        return bv_data_1.placeholder;
    }
    if (!bv_validator_1.isValue(val)) {
        var newVal = 0;
        return newVal.toFixed(cent);
    }
    // eslint-disable-next-line prefer-const
    var _a = __read(Number(val).toFixed(cent).split('.'), 2), int = _a[0], float = _a[1];
    int = int.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 将整数部分逢三一断
    var result = float ? int + "." + float : int;
    return "" + result + (suffix !== null && suffix !== void 0 ? suffix : '');
};
exports.numberFormat = numberFormat;
var clearNoNum = function (val) {
    var newVal = val.toString();
    newVal = newVal.replace(/[^\d.-]/g, ""); // 清除"数字","-"和"."以外的字符
    newVal = newVal.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
    newVal = newVal.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    newVal = newVal.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
    if (newVal !== '-' && newVal.indexOf(".") < 0 && newVal !== "") { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        newVal = parseFloat(newVal).toString();
    }
    return newVal;
};
exports.clearNoNum = clearNoNum;
var numberInputFormat = function (val) {
    if (!val) {
        return '';
    }
    // eslint-disable-next-line prefer-const
    var _a = __read(clearNoNum(val).split('.'), 2), int = _a[0], float = _a[1];
    int = int.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') || 0;
    return (float || (float === null || float === void 0 ? void 0 : float.trim()) === '') ? int + "." + float : int;
};
exports.numberInputFormat = numberInputFormat;
var numberInputParser = function (val) {
    return (val === null || val === void 0 ? void 0 : val.replace(/\$\s?|(,*)/g, '')) || '';
};
exports.numberInputParser = numberInputParser;
var transformEnum = function (val) {
    if (lodash_1.isPlainObject(val)) {
        return Object.keys(val).map(function (item) { return ({ value: item, title: val[item] }); });
    }
    if (bv_validator_1.isArray(val) && !bv_validator_1.isObj(val[0])) {
        return (val === null || val === void 0 ? void 0 : val.map(function (x, n) { return ({ value: n.toString(), title: x }); }));
    }
    return val;
};
exports.transformEnum = transformEnum;
// [{value: '1', title: '示例'}] => { 1: '示例' }
var arr2Obj = function (arr, value, title) {
    if (value === void 0) { value = 'value'; }
    if (title === void 0) { title = 'title'; }
    var obj = {};
    arr.forEach(function (item) { obj[item[value]] = item[title]; });
    return obj;
};
exports.arr2Obj = arr2Obj;
// 数组去重
var duplicateRemoval = function (arr) {
    return Array.from(new Set(arr));
};
exports.duplicateRemoval = duplicateRemoval;
var splitMultiple = function (val) { return (val.split(RegExp(/[/、;；:,， \r\n]/)).filter(function (item) { return bv_validator_1.isValue(item); })); };
exports.splitMultiple = splitMultiple;
